export default __webpack_public_path__ + "static/bg6-b28316ee9fe276bd128d2ead6232288c.jpg";